
        var result = require("!!../../../../node_modules/css-loader/index.js!./quantity-discount.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/quantity-discount.component.css
// module id = 2346
// module chunks = 1